function Load() {
	return (
		<div className="loader">
			<svg className="circle-loader" width="40" height="40" version="1.1" xmlns="http://www.w3.org/2000/svg">
				<circle cx="20" cy="20" r="8"/>
			</svg>
		</div>
	);
}

module.exports = Load;


// WEBPACK FOOTER //
// ./resources/js/components/mixins/Load.js